import authRules from '../authRules.js';

const mySchedule = (user) => {
  const { mySchedule } = user.securityLevels;
  if (mySchedule >= authRules.mySchedule.mySchedule) {
      return true;
  } else {
      return false;
    }
  }

export default mySchedule;
